import React from "react";

export default function ShareButton({ icon, text, href }) {
  return (
    <a href={href} className="share_button">
      {icon}
      {text}
    </a>
  );
}
